import {createSlice, PayloadAction, SerializedError} from '@reduxjs/toolkit'
import {PostgrestError} from "@supabase/supabase-js";

export enum Severity {
    Success,
    Info,
    Warning,
    Error
}


export type ErrorMessage = {
    message: string;
    severity?: Severity;
}
type ErrorMsg = {
    msg: string
}

export type ExtendedError = ErrorMessage | ErrorMsg;


export type ErrorPayload = ExtendedError | Array<ErrorMessage>|PostgrestError |  SerializedError;

type ErrorState = {
    errorState: boolean;
    messages: Array<ErrorMessage>;
    archive: Array<ErrorMessage>;
}


const initialState: ErrorState = {
    errorState: false,
    messages: [],
    archive: []
}

const errorsSlice = createSlice({
    name: "errors",
    initialState,
    reducers: {
        newError: (state, action: PayloadAction<ErrorPayload>) => {},
        pushError: (state, action: PayloadAction<ErrorMessage>) => {
            state.messages.push(action.payload);
            state.errorState = true;
        },
        popError: (state) => {
            const e = state.messages.pop()
            if (e) {
                state.archive.push(e);
            }
            state.errorState = state.messages.length > 0
        },
        expireError: (state, action: PayloadAction<number>) => {
            const e = state.messages.splice(action.payload, 1)
            state.archive.push(...e)
            state.errorState = state.messages.length > 0
        },
        playErrorSound: (state, action:PayloadAction<Severity>) => {

        }
    },
});

export const {
    popError, pushError, expireError, newError, playErrorSound
} = errorsSlice.actions
export const reducer = errorsSlice.reducer;




